module.exports = __webpack_public_path__ + "static/img/00054B_2_5_6_8_R_20200611_fit.b29e3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/00054B_2_5_6_8_R_20200611_fit.png
// module id = UpJ2
// module chunks = 0